/**
 * Premier affichage du widget, avant la fiche du studio (Run 5) : la bande des
 * jours et trois cours en gris, aux couleurs du widget (jetons de theme, fond
 * data-background), sans texte : rien a traduire avant de connaitre la langue.
 */
export function WidgetSkeleton() {
  return (
    <div aria-busy="true" className="flex flex-col gap-4 px-4 py-5 motion-safe:animate-pulse">
      <div className="flex gap-2 overflow-hidden" aria-hidden="true">
        {Array.from({ length: 7 }, (_, i) => (
          <div key={i} className="flex h-14 min-w-11 flex-1 flex-col items-center justify-center gap-1.5 rounded-control bg-surface-sunken/60">
            <div className="h-2 w-5 rounded-pill bg-surface-sunken" />
            <div className="h-3 w-4 rounded-pill bg-surface-sunken" />
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-3" aria-hidden="true">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex items-center gap-4 rounded-card border border-line-soft bg-surface p-4">
            <div className="h-10 w-12 shrink-0 rounded-control bg-surface-sunken" />
            <div className="flex flex-1 flex-col gap-2">
              <div className="h-3 w-2/5 rounded-pill bg-surface-sunken" />
              <div className="h-2.5 w-3/5 rounded-pill bg-surface-sunken/70" />
            </div>
            <div className="h-9 w-20 shrink-0 rounded-pill bg-surface-sunken/70" />
          </div>
        ))}
      </div>
    </div>
  );
}
